/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Placeholders_Creem_Test_AmountInputs */

const en_admin_settings_placeholders_creem_test_amount = /** @type {(inputs: Admin_Settings_Placeholders_Creem_Test_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty to use real amount, 1 = $0.01`)
};

/**
* | output |
* | --- |
* | "Leave empty to use real amount, 1 = $0.01" |
*
* @param {Admin_Settings_Placeholders_Creem_Test_AmountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_placeholders_creem_test_amount = /** @type {((inputs?: Admin_Settings_Placeholders_Creem_Test_AmountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Placeholders_Creem_Test_AmountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_placeholders_creem_test_amount(inputs)
});
export { admin_settings_placeholders_creem_test_amount as "admin.settings.placeholders.creem_test_amount" }